import { push } from 'connected-react-router'

import {
  FORBIDDEN_REQUEST
} from '../reducers/currentUser'

import {
  checkIfErrorCodePresent
} from '../utils/errorHandling'

// Action Parsing

const actionIsForbiddenRequest = (action) => {
  if (action.error && action.meta.previousAction) {
    return checkIfErrorCodePresent(action.error, 'forbidden')
  }
}

// Event Triggers

const dispatchForbiddenRequestEvents = (dispatch) => {
  dispatch({ type: FORBIDDEN_REQUEST })

  dispatch(push('/hospitals'))
}

// Exports

export const handleForbiddenRequests = ({ dispatch, getState }) => {
  return (next) => (action) => {
    if (actionIsForbiddenRequest(action)) {
      return new Promise((resolve, reject) => {
        dispatchForbiddenRequestEvents(dispatch)
        reject({ type: FORBIDDEN_REQUEST })
      })
    }

    return next(action)
  }
}
